import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ProPricesStyles } from './ProPrice.style';

const ProPrice = ({ proPrice, regionCode, getPrice, getUnitPrice }) => {
  if (!Object.entries(proPrice).length) {
    return null;
  }

  const prices = proPrice?.prices[0];

  return (
    <div className="pro-prices-container">
      <div className="pro-prices-icon-container">
        {regionCode === 'cl' ? (
          <div className="pro-prices-icon-cl">
            <p>PRECIO MAYORISTA</p>
          </div>
        ) : (
          <i className="pro-prices-icon-pe" />
        )}
        <div className={classNames(`pro-prices-badge ${regionCode}`)}>
          {`sobre ${proPrice?.metadata?.quantityToBuyValue} un`}
        </div>
      </div>
      <div>
        {prices?.unitPrice ? (
          <p className="pro-price">
            <span className="unit-pro-price">
              {getUnitPrice(prices?.unitPrice, prices?.symbol)} <span className="divider">|</span>{' '}
            </span>
            {getPrice(prices?.price, prices?.symbol)} {prices?.unitPrice ? prices?.unitPrice?.unitForSale : 'und'}
          </p>
        ) : (
          <p className="pro-price-no-unit">{getPrice(prices?.price, prices?.symbol)} und</p>
        )}
      </div>
      <style jsx>{ProPricesStyles}</style>
    </div>
  );
};

ProPrice.defaultProps = {
  getPrice: () => {},
  proPrice: {},
  regionCode: 'cl',
  getUnitPrice: () => {},
};

ProPrice.propTypes = {
  getPrice: PropTypes.func,
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
  getUnitPrice: PropTypes.func,
};

export default ProPrice;
